import type { BaseQueryFn, EndpointBuilder, FetchArgs } from '@reduxjs/toolkit/query';

export enum ApiEndpointTags {
    Subscription = 'Subscription',
    Subscriptions = 'Subscriptions',
}

export type ImagoMpApiQueryBuilder = EndpointBuilder<
    BaseQueryFn<string | FetchArgs, unknown>,
    ApiEndpointTags,
    'imagoMpApi'
>;

export type ImagoMpApiQuery = Parameters<ImagoMpApiQueryBuilder['query']>[0];
export type ImagoMpApiMutation = Parameters<ImagoMpApiQueryBuilder['mutation']>[0];
